import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

interface IProps extends ComponentProps<"div"> {
    hotlinePhoneNumber: string;
    customMessage?: string;
}

export const HotlineInfo = ({className, customMessage, hotlinePhoneNumber, ...rest}: IProps) => {
    const {isMobile} = useUserDevice();
    const phoneNumber = phoneNumberFormat(hotlinePhoneNumber);

    const handlePhoneNumberClick = () => {
        window.location.href = `tel:+${hotlinePhoneNumber}`;
    };

    return (
        <div className={cx(container, className)} {...rest}>
            <div>
                {customMessage ? (
                    <Text variant="body_copy_2">{customMessage}</Text>
                ) : (
                    <>
                        <Text variant="info_txt_3" strong>
                            DORADCA MIESZKANIOWY
                        </Text>
                        <Text variant="info_txt_3">
                            Bezpłatne znajdziemy dla <br />
                            Ciebie mieszkanie
                        </Text>
                    </>
                )}
            </div>

            <div className={phoneContainer}>
                <PhoneIcon size="1.44" wrapperSize="2.4" wrapperColor="var(--colors-primary)" />

                {isMobile ? (
                    <Text variant="body_copy_2" strong onClick={handlePhoneNumberClick}>
                        {phoneNumber}
                    </Text>
                ) : (
                    <Text variant="body_copy_2" strong>
                        {phoneNumber}
                    </Text>
                )}
            </div>
        </div>
    );
};

const container = css({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    px: 1.5,
    py: "6px",
    bg: "var(--colors-background-200)",
    w: "100%",
    borderRadius: 1,

    md: {
        maxW: 320
    }
});

const phoneContainer = css({
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifySelf: "end"
});
import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

interface IProps extends ComponentProps<"div"> {
    hotlinePhoneNumber: string;
    customMessage?: string;
}

export const HotlineInfo = ({className, customMessage, hotlinePhoneNumber, ...rest}: IProps) => {
    const {isMobile} = useUserDevice();
    const phoneNumber = phoneNumberFormat(hotlinePhoneNumber);

    const handlePhoneNumberClick = () => {
        window.location.href = `tel:+${hotlinePhoneNumber}`;
    };

    return (
        <div className={cx(container, className)} {...rest}>
            <div>
                {customMessage ? (
                    <Text variant="body_copy_2">{customMessage}</Text>
                ) : (
                    <>
                        <Text variant="info_txt_3" strong>
                            DORADCA MIESZKANIOWY
                        </Text>
                        <Text variant="info_txt_3">
                            Bezpłatne znajdziemy dla <br />
                            Ciebie mieszkanie
                        </Text>
                    </>
                )}
            </div>

            <div className={phoneContainer}>
                <PhoneIcon size="1.44" wrapperSize="2.4" wrapperColor="var(--colors-primary)" />

                {isMobile ? (
                    <Text variant="body_copy_2" strong onClick={handlePhoneNumberClick}>
                        {phoneNumber}
                    </Text>
                ) : (
                    <Text variant="body_copy_2" strong>
                        {phoneNumber}
                    </Text>
                )}
            </div>
        </div>
    );
};

const container = css({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    px: 1.5,
    py: "6px",
    bg: "var(--colors-background-200)",
    w: "100%",
    borderRadius: 1,

    md: {
        maxW: 320
    }
});

const phoneContainer = css({
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifySelf: "end"
});
